export { default, PassSvg } from './PassSvg';